<template>
    <BreadCrumb PageTitle="Statistiques des avis sur les talents" />
    <StatistiquesSignalements/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import StatistiquesSignalements from "../../components/AvisTalents/StatistiquesSignalements.vue";

    export default defineComponent({
      name: "StatistiquesSignalementsPage",
      components: {
        BreadCrumb,
        StatistiquesSignalements,
      },
    });
  </script>